import firebase from 'firebase'

const config = {
  apiKey: "AIzaSyDCPU6nZm5qZoin8xoJOpjxfesm6JYImv8",
  databaseURL: "https://branddeck-app.firebaseio.com/"
}
firebase.initializeApp(config)
export const db = firebase.database()
export const auth = firebase.auth()
